import React, { MouseEventHandler } from 'react';
import Separator from '@westwing/ui-kit/Separator';
import template from '@westwing/ui-kit/template';
import EmailIcon from '@westwing/ui-kit/Icons/EmailIcon';
import {
    StyledHeader,
    StyledModalTitle,
    StyledModalContent,
    StyledLink,
    StyledListItem,
    StyledLinkButton,
    StyledPrimaryLinkButton,
    StyledModalParagraph,
    StyledHeaderIcon,
} from '../loginAndRegistration.style';
import useTranslate from 'Hooks/useTranslate';

type MagicLinkConfirmationProps = {
    email: string;
    expirationTime: string;
    onEmailEdit?: (closeModal?: boolean) => void;
    editEmailUrl?: string;
    onResend: MouseEventHandler<HTMLButtonElement>;
    resendEmailView?: boolean;
};

const MagicLinkConfirmation = ({
    email,
    expirationTime,
    editEmailUrl,
    onEmailEdit,
    onResend,
    ...props
}: MagicLinkConfirmationProps): JSX.Element => {
    const { tPlain: t } = useTranslate();

    const title = t('We sent you an email with your login-link!');
    const inboxCheck = t('Check the inbox of %s', [email]);
    const linkDescription = t('Simply click on the login-link to continue shopping_Bella', [expirationTime]);
    const editEmailLabel = t('Oops! I have entered a wrong email address.');
    const resendLabel = t('Send e-mail again');
    return (
        <div {...props}>
            <StyledHeader>
                <StyledHeaderIcon>
                    <EmailIcon />
                </StyledHeaderIcon>
                <StyledModalTitle>{title}</StyledModalTitle>
            </StyledHeader>
            <StyledModalContent>
                <StyledModalParagraph>{inboxCheck}</StyledModalParagraph>
                <StyledModalParagraph dangerouslySetInnerHTML={{ __html: template(linkDescription) }} />
                <Separator />
                <ul>
                    <StyledListItem>
                        {editEmailUrl ? (
                            <StyledLink to={editEmailUrl}>{editEmailLabel}</StyledLink>
                        ) : (
                            <StyledPrimaryLinkButton onClick={() => onEmailEdit?.(false)}>
                                {editEmailLabel}
                            </StyledPrimaryLinkButton>
                        )}
                    </StyledListItem>
                    <StyledListItem>
                        <StyledLinkButton onClick={onResend}>{resendLabel}</StyledLinkButton>
                    </StyledListItem>
                </ul>
            </StyledModalContent>
        </div>
    );
};
export default MagicLinkConfirmation;
